export const INVITE_LINK_CREATED = "Invite Link :";
export const CREATE_INVITE_LINK = "Create a new Invite Link";
export const JOIN_INVITE_LINK = "Join a Invite Link";

export const PEOPLES = "People";
export const VIDEOCHAT_HEAD = "Chat";
export const LOGOUT = "Logout";